import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100% !important;
  margin: 0px 0px 0px 0px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  // Pop Up Errores
  #popup-error {
    width: auto;
    max-width: 380px;
    height: auto;
    margin: 0px 0px 40px 40px;
    padding: 24px 24px 24px 24px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: var(--blanco);
    border-radius: 16px;
    border: 1px solid var(--grisClaro);
    box-shadow: 0px 4px 20px var(--sombraNaranja);
    transform-origin: top center;
    animation-name: animation-in;
    animation-duration: 0.4s;
    animation-iteration-count: initial;
    animation-timing-function: ease-out;
    z-index: 100;
  }

  // Animación Entrada Popup Erorres
  @keyframes animation-in {
    from {
      transform: translate(0px, 300px);
    }
    to {
      transform: translate(0px, 0px);
    }
  }

  // Pop Up Errores Ícono
  #popup-error span {
    margin: 3px 10px 0px 0px;
    color: var(--naranja100);
    font-size: 17px;
  }

  // Pop Up Errores Texto
  #popup-error p {
    width: 100%;
    margin: 0px 0px 0px 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    color: var(--gris);
    font-size: 13.5px;
    font-weight: 400;
    text-align: left;
    line-height: 24px;
  }

  // Max Width Container
  #max-width-container {
    width: 1270px;
    margin: 0px 0px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  // Texto Container
  #formulario-container {
    width: 700px;
    margin: 0px 0px 0px 0px;
    padding: 116px 200px 92px 0px;
    border-right: 1px solid var(--grisClaro);
  }

  // Mapa Container
  #mapa-container {
    width: 100%;
    margin: 24px 0px 0px 0px;
    border-top: 1px solid var(--grisClaro);
  }

  // Titulo
  h3 {
    width: 100%;
    margin: 0px 0px 0px 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    font-size: 20px;
    color: var(--lila90);
  }

  // Titulo Mapa Container
  #mapa-container h3 {
    margin: 48px 0px 0px 0px;
  }

  // Texto
  #formulario-container p {
    width: 100%;
    margin: 16px 0px 0px 0px;
    text-align: left;
    font-size: 14px;
    color: var(--gris);
    line-height: 32px;
  }

  // Texto Completa
  #completa {
    margin: 16px 0px 0px 0px;
  }

  // Formulario
  form {
    width: 100%;
    margin: 56px 0px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;
  }

  // Datos Personales, Número de Poliza, Mensaje Motivo, Captcha Container, Boton Container
  #datos-personales,
  #asunto,
  #mensaje-motivo,
  #captcha-container,
  #boton-container {
    width: 100%;
    margin: 0px 0px 40px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
  }

  // Datos Personales Titulo y Mensaje Motivo Titulo
  #datos-personales h4,
  #asunto h4,
  #mensaje-motivo h4 {
    width: 100%;
    margin: 0px 0px 32px 0px;
    font-size: 13px;
    font-weight: 500;
  }

  // Input Container
  .input-container {
    width: 30%;
    margin: 0px 16px 0px 0px;
    position: relative;
  }

  // Textarea Container
  #textarea-mensaje-container {
    width: calc(60% + 16px);
  }

  // Input y Label
  .input-container input,
  .input-container textarea,
  .input-container label {
    -webkit-transition: all 0.2s;
    transition: all 0.2s;
    z-index: 58 !important;
  }

  // Inputs
  .input-container input,
  .input-container textarea {
    width: 100%;
    height: 35px;
    padding: 0px 16px 0px 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 0.75em;
    //color: var(--gris);
    color: #595959;
    border: 1px solid rgb(152, 152, 154, 0.3);
    background-color: #fefefe;
    -webkit-appearance: none;
    box-shadow: 0;
    transition: 0.2s all;
    border-radius: 6px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  // Textarea
  .input-container textarea {
    min-width: 100%;
    max-width: 100%;
    height: 140px !important;
    max-height: 140px;
    min-height: 140px;
    padding: 16px 16px 16px 16px !important;
  }

  // Label
  .input-container label {
    position: absolute;
    top: 0.95em;
    left: 0;
    margin: 0px 0px 0px 16px;
    line-height: 1;
    font-size: 0.75em;
    font-weight: 400;
    color: rgb(152, 152, 154, 0.6);
    cursor: text;
    z-index: 60 !important;
  }

  // Input On Focus Label
  .input-container input:focus + label,
  .input-container textarea:focus + label {
    top: -0.6em;
    background-color: var(--blanco);
    padding: 0px 6px 0px 6px;
    margin: 0px 0px 0px 11px;
    font-weight: 500;
    font-size: 0.7em;
    color: var(--naranja100) !important;
    z-index: 80 !important;
  }

  // Inputs Focus
  .input-container input:focus,
  .input-container textarea:focus {
    border: 1px solid var(--naranja100);
    outline: none;
    z-index: 59 !important;
  }

  // Label Down
  .label-down {
    z-index: 57 !important;
  }

  // Label Top
  .label-top {
    top: -0.6em !important;
    background-color: var(--blanco);
    padding: 0px 6px 0px 6px;
    margin: 0px 0px 0px 11px !important;
    font-weight: 500 !important;
    font-size: 0.7em !important;
    color: #041726 !important;
    z-index: 80 !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield !important;
  }

  // Input Error
  .input-error {
    border: 1px solid red !important;
  }

  // Botón Container Botón
  #boton-container button {
    padding: 7px 24px 7px 24px;
    border-radius: 8px;
    border: 0px solid;
    color: var(--blanco);
    background-color: var(--naranja100);
    cursor: pointer !important;
    transition: 0.2s;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
  }

  #boton-container button span {
    font-size: 20px;
    margin: -1px 0px 0px 12px;
  }

  #boton-container button:hover {
    background-color: var(--naranja40) !important;
  }

  // Plazos Container
  #plazos-container {
    width: 230px !important;
    padding: 116px 0px 145px 64px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-self: flex-start;
    z-index: 96;
  }

  // Plazos Container Titulo
  #plazos-container p {
    width: 100%;
    margin: 0px 0px 12px 0px;
    font-size: 13px;
    font-weight: 600;
    color: var(--lila90);
  }

  // Plazos Container Texto
  #plazos-texto {
    font-weight: 400 !important;
    color: var(--gris) !important;
    font-size: 12.5px !important;
  }

  // Nav Container Div
  #plazos-container div {
    width: 100%;
    margin: 0px 0px 0px 0px;
    padding: 12px 0px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
    border-top: 1px solid var(--grisClaro);
  }

  // Plazos Container Botones
  #plazos-container a {
    width: auto;
    margin: 0px 40px 12px 0px;
    font-size: 12.5px;
    font-weight: 400;
    color: var(--gris);
    transition: 0.1s all;
  }

  // Nav Container Botones Hover
  #plazos-container a:hover {
    color: var(--naranja100);
  }

  // Mapa Container Mapa
  #mapa-container iframe {
    margin: 40px 0px 0px 0px;
    border: 0px;
    border-radius: 16px;
  }

  // Transporte Container
  #transporte-container {
    width: 100%;
    margin: 48px 0px 0px 0px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
  }

  // Transporte Container Titulo
  #transporte-container h3 {
    width: 100%;
    margin: 0px 0px 0px 0px;
  }

  // Transporte Container Div
  #transporte-container div {
    width: auto;
    margin: 32px 0px 0px 0px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
  }

  // Transporte Container Div Texto
  #transporte-container div h4 {
    width: 100%;
    margin: 0px 0px 16px 0px;
    font-size: 13px;
    font-weight: 500;
  }

  // Transporte Container Div Span
  #transporte-container div span {
    width: auto;
    margin: 0px 4px 0px 4px;
    padding: 3px 8px 2px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    color: var(--blanco);
    font-size: 11px;
    font-weight: 600;
    background-color: var(--naranja100);
    border-radius: 4px;
  }

  // Colores de lineas y ramales
  #linea115,
  #linea180,
  #subteB {
    background-color: #fe0034 !important;
  }

  #linea130,
  #linea45,
  #linea50,
  #subteD {
    background-color: #346702 !important;
  }

  #linea140 {
    background-color: #999999 !important;
  }

  #subteC {
    background-color: #0168b5 !important;
  }

  #trenes span {
    background-color: #0090d6 !important;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Max Width Container
    #max-width-container {
      max-width: 1000px;
    }

    // Texto Container
    #formulario-container {
      width: 630px;
      padding: 80px 64px 80px 0px;
    }

    // Input Container
    .input-container {
      width: 35%;
    }

    // Input Teléfono
    #input-telefono-container {
      margin: 32px 0px 0px 0px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Max Width Container
    #max-width-container {
      max-width: 680px;
    }

    // Texto Container
    #formulario-container {
      width: 100%;
      padding: 80px 0px 80px 0px;
      border: 0;
    }

    // Plazos Container
    #plazos-container {
      display: none;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Max Width Container
    #max-width-container {
      max-width: 85%;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Input Container
    .input-container {
      width: 45%;
    }
  }

  // 414px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile414}) {
    // Datos Personales Titulo y Mensaje Motivo Titulo
    #datos-personales h4,
    #asunto h4,
    #mensaje-motivo h4 {
      margin: 0px 0px 8px 0px;
    }

    // Input Container
    .input-container {
      width: 100%;
      margin: 24px 0px 0px 0px;
    }

    // Textarea Container
    #textarea-mensaje-container {
      width: 100%;
      margin: 24px 0px 0px 0px;
    }
  }
`;

export default Container;
